import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@core/ngrx-legacy';

import { NotificationsCounterFilteredActions } from './notification-counter-filtered.store';
import { NotificationsCounterFilteredHttpService } from './notification-counter-http-filtered.service';

@Injectable({ providedIn: 'root' })
export class NotificationsCounterFilteredEffects {
  private readonly actions$ = inject(Actions);
  private readonly notificationsCounterFilteredHttpService = inject(
    NotificationsCounterFilteredHttpService,
  );

  public effects = createEffectFactory(NotificationsCounterFilteredActions, this.actions$);

  public fetch$ = this.effects(NotificationsCounterFilteredActions.fetch, ({ payload }) =>
    this.notificationsCounterFilteredHttpService.fetch(payload.filters),
  );
}
